import React from "react"
import PropTypes from "prop-types"
import ReservationDetailModal from "pagesV2/pro/Bookings/ReservationDetailPage/ReservationDetailModal"
import Journal from "../../../Modals/Journal"
import NonAgendaWeekView from "./NonAgendaWeekView"
import AgendaWeekView from "./AgendaWeekView"
import useWeekGridData from "./useWeekGridData"
import { useCalendarBlackouts } from "pagesV2/pro/Calendar/hooks/useCalendarBlackouts"

const WeekGrid = ({ calendarDays, hours, events, agenda, startHour: startHourProp, endHour: endHourProp, onOpenDayPanel }) => {
  const { getDay: getDayBlackout, getBookingConflict } = useCalendarBlackouts()
  const {
    isBookingModalOpen, setIsBookingModalOpen, selectedBookingId, setSelectedBookingId,
    selectedDate, isJournalModalOpen, isCompact, active,
    canViewJournal, canCreateJournal, canEditJournal, journalNoteDates,
    startHour, endHour, totalHeight, timeOffByDay, isWeekEmpty,
    normalizedEventsByDay, eventsByDayWithCols, gridTemplateColumns, gridMinWidth,
    getVisibleCount, showMore, showLess, MAX_VISIBLE,
    handleJournalOpen, handleJournalClose, handleBookingCancelSuccess,
  } = useWeekGridData({ calendarDays, events, hours, agenda, startHourProp, endHourProp })

  const weekStartDate = calendarDays?.[0]?.format("YYYY-MM-DD")
  const weekEndDate = calendarDays?.at(-1)?.format("YYYY-MM-DD")
  const sharedProps = { calendarDays, timeOffByDay, journalNoteDates, isCompact, active, canViewJournal, canCreateJournal, canEditJournal, setIsBookingModalOpen, setSelectedBookingId, onJournalOpen: handleJournalOpen, normalizedEventsByDay, getDayBlackout, getBookingConflict, onOpenDayPanel }

  return (
    <>
      {agenda ? (
        <AgendaWeekView {...sharedProps} hours={hours} totalHeight={totalHeight} startHour={startHour} endHour={endHour} gridTemplateColumns={gridTemplateColumns} gridMinWidth={gridMinWidth} eventsByDayWithCols={eventsByDayWithCols} />
      ) : (
        <NonAgendaWeekView {...sharedProps} isWeekEmpty={isWeekEmpty} getVisibleCount={getVisibleCount} showMore={showMore} showLess={showLess} MAX_VISIBLE={MAX_VISIBLE} />
      )}
      {isJournalModalOpen && (
        <Journal open={isJournalModalOpen} setOpen={handleJournalClose} onCancel={handleJournalClose} selectedDate={selectedDate} startDate={weekStartDate} endDate={weekEndDate} />
      )}
      {isBookingModalOpen && (
        <ReservationDetailModal open={isBookingModalOpen} bookingUuid={selectedBookingId} onClose={handleBookingCancelSuccess} />
      )}
    </>
  )
}

WeekGrid.propTypes = {
  calendarDays: PropTypes.array.isRequired,
  hours: PropTypes.array.isRequired,
  events: PropTypes.array.isRequired,
  agenda: PropTypes.bool,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
  onOpenDayPanel: PropTypes.func,
}

export default WeekGrid
